import superagent from 'superagent';
import webservice from './webservice';
import getCookie from './getCookie';

export default async function getData({ jsonBody }) {
  const url = `${webservice}/postContratoActualiza`;
  const Dominio =
    (window.location.hostname === 'localhost' && 'intranettmb.dyndns.org') ||
    window.location.hostname;

  let response = {};

  await superagent
    .post(url)
    .set('Content-Type', 'application/json')
    .set('Dominio', 'application/json')
    .auth(getCookie('TMBcartToken'), { type: 'bearer' })
    .send(jsonBody)
    .set('Dominio', Dominio)
    .then((res) => {
      if (res && res.body) response = res.body;
    })
    .catch((err) => {
      console.log(err);
      const resp = {
        ...jsonBody,
        error: err,
        tipoMensaje: 'error',
        mensaje: 'Error',
      };
      response = resp;
    });

  return response;
}
